import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PollingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PollingQuery = {
  accessPolling: { __typename: 'Polling'; appendToTracking: Types.Scalars['Map']['output'] } | null;
};

export const PollingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Polling' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessPolling' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'appendToTracking' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PollingQuery, PollingQueryVariables>;
